import React from "react";
import PhoneMockup from "./PhoneMockup";

const projects = [
  {
    tag: "Business",
    name: "Business CRM & Tools",
    year: "",
    desc: "CRM & operations apps: customer records, sales pipelines, invoicing, and third‑party integrations.",
    image: "/assets/crm.png",
    accent: "bg-acid",
    span: "md:col-span-7",
    offset: "md:mt-0",
  },
  {
    tag: "Health",
    name: "Healthcare & Wellness",
    year: "",
    desc: "Patient workflows, telemedicine front-ends, encrypted local stores, and background sync.",
    image:
      "/assets/health.png",
    accent: "bg-ultra",
    span: "md:col-span-5",
    offset: "md:mt-20",
  },
  {
    tag: "Lifestyle",
    name: "Consumer & Lifestyle",
    year: "",
    desc: "Personal assistants, habit builders, and media-forward apps with polished mobile UX.",
    image:
      "/assets/shop.png",
    accent: "bg-ink",
    span: "md:col-span-5",
    offset: "md:mt-0",
  },
  {
    tag: "Custom",
    name: "Custom Android Apps",
    year: "",
    desc: "Custom built mobile apps designed for your business, workflow, and users.",
    image:
      "/assets/travel.png",
    accent: "bg-acid",
    span: "md:col-span-7",
    offset: "md:mt-16",
  },
];

const ProjectCard = ({ p, idx }) => {
  return (
    <article
      data-testid={`project-card-${idx}`}
      className={`group relative ${p.span} ${p.offset}`}
    >
      <div className="flex flex-col gap-6">
        <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.22em] text-ink/60">
          <span className="rounded-sm border border-ink px-2 py-1">
            {p.tag}
          </span>
          <span>{p.year}</span>
        </div>

        <div className="relative overflow-hidden rounded-sm border border-ink/10 bg-white p-6 md:p-10">
          <div
            className={`absolute -top-10 -right-10 h-44 w-44 rounded-full ${p.accent} blur-2xl opacity-70`}
          />

          <div className="relative flex items-center justify-center py-6">
            <PhoneMockup className="h-[380px] w-[190px] md:h-[460px] md:w-[230px]">
              <img
                src={p.image}
                alt={p.name}
                className="h-full w-full object-cover"
                loading="lazy"
              />

              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent p-3 text-cream">
                <div className="font-mono text-[9px] uppercase tracking-widest opacity-80">
                  {p.tag}
                </div>

                <div className="font-display text-lg font-extrabold leading-tight">
                  {p.name}
                </div>
              </div>
            </PhoneMockup>
          </div>
        </div>

        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-display text-3xl font-extrabold uppercase tracking-tightest text-ink md:text-4xl">
              {p.name}
            </h3>

            <p className="mt-2 max-w-sm font-body text-base text-ink/70">
              {p.desc}
            </p>
          </div>
        </div>
      </div>
    </article>
  );
};

const Portfolio = () => {
  return (
    <section
      id="work"
      data-testid="portfolio-section"
      className="relative bg-cream py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1480px] px-6 md:px-12">
        <div className="mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="font-mono text-xs uppercase tracking-[0.22em] text-ultra">
              03 — Our Capabilities
            </div>

            <h2 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.92] tracking-tightest text-ink md:text-7xl">
              Types of
              <br />
              apps we <span className="italic text-ultra">build.</span>
            </h2>
          </div>

          <p className="max-w-md font-body text-lg text-ink/70">
            We design and ship mobile apps across finance, health, lifestyle and
            travel — secure, resilient, and optimised for real-world use.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-12">
          {projects.map((p, i) => (
            <ProjectCard key={p.name} p={p} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;